// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__GX_oJ","title":"styles_title__rGk9m","tabs":"styles_tabs__AVog7","tabItem":"styles_tabItem__0gXeG","active":"styles_active__H5p35"};